import classNames from "classnames/dedupe";
import React, { FC, MouseEvent } from "react";

import { Image } from "../../../Utility/MediaBuilder/Image/Image";
import { IImageData } from "../../../Utility/MediaBuilder/Image/Image.interface";

export interface IProductPreviewItemProps {
  id?: string;
  /**
   **Image source for preview item
   */
  image?: IImageData;
  /**
   * Custom component to display image for preview item
   * This will override image prop
   */
  customImage?: JSX.Element;
  /**
   * Function to get id of Product variant and set
   * this variant as main
   */
  onHover?: (id: string, event: MouseEvent) => void;
  onClick?: (id: string, event: MouseEvent) => void;
  /**
   * Set if Item is currently selected
   *
   */
  active?: boolean;
}

const ProductPreviewItem: FC<IProductPreviewItemProps> = (props) => {
  const { image, customImage, onHover, id, active, onClick } = props;
  const rootClasses = classNames("product-preview__item", {
    active,
  });

  const handleHover = (event: MouseEvent) => {
    onHover?.(id, event);
  };

  const handleOnClick = (event: MouseEvent) => {
    onClick?.(id, event);
  };

  return (
    <div
      onMouseEnter={handleHover}
      className={rootClasses}
      data-testid="product-preview-item"
      onClick={handleOnClick}
    >
      {customImage || <Image src={image?.src} alt={image?.alt} />}
    </div>
  );
};

export default ProductPreviewItem;
